var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.131 1.15961C16.5684 0.597196 15.8055 0.28125 15.01 0.28125C14.2145 0.28125 13.4516 0.597196 12.889 1.15961L12.182 1.86761L17.132 6.81761L17.838 6.11061C18.1167 5.83203 18.3377 5.50129 18.4885 5.13728C18.6393 4.77327 18.7169 4.38312 18.7169 3.98911C18.7169 3.5951 18.6393 3.20495 18.4885 2.84094C18.3377 2.47693 18.1167 2.14619 17.838 1.86761L17.131 1.15961ZM15.717 8.23161L10.767 3.28161L1.67703 12.3726C1.47811 12.5716 1.33915 12.8224 1.27603 13.0966L0.247026 17.5516C0.208685 17.717 0.213083 17.8894 0.259805 18.0526C0.306527 18.2159 0.394036 18.3645 0.514085 18.4846C0.634134 18.6046 0.78277 18.6921 0.94599 18.7388C1.10921 18.7856 1.28164 18.79 1.44703 18.7516L5.90303 17.7236C6.17683 17.6603 6.42735 17.5214 6.62603 17.3226L15.717 8.23161Z",
    fill: "#314450"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPencil);
export default __webpack_public_path__ + "static/media/Ic_Pencil.1c711cfda633ace1b514ad242270e5a0.svg";
export { ForwardRef as ReactComponent };